import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";
const getDefaultSelectedTrainSetMapping = () => {
  return {
    name: null,
    description: null,
    fromTrainSetId: null,
    toTrainSetId: null,
    seatTemplateMapping: [],
  };
};
export default {
  state: () => ({
    trainSetMappings: [],
    selectedTrainSetMapping: getDefaultSelectedTrainSetMapping(),
  }),

  mutations: {
    setTrainSetMappings(state, trainSetMappings) {
      Vue.set(state, "trainSetMappings", trainSetMappings);
    },
    setSelectedTrainSetMapping(state, selectedTrainSetMapping) {
      Vue.set(state, "selectedTrainSetMapping", selectedTrainSetMapping);
    },
    setDefaultSelectedTrainSetMapping(state) {
      Vue.set(state, "selectedTrainSetMapping", getDefaultSelectedTrainSetMapping());
    },
    setDefaultTrainSetMappingModule(state) {
      Vue.set(state, "selectedTrainSetMapping", getDefaultSelectedTrainSetMapping());
      Vue.set(state, "trainSetMappings", []);
    },
  },

  actions: {
    loadTrainSetMappings: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/train-set-mapping/entity")
        .then((response) => {
          // context.commit("setTrainSetMappings", response.data);
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPublishedTrainSetMappings: (context) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/train-set-mapping/entity/published")
          .then((response) => {
            // context.commit("setTrainSetMappings", response.data);
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadSelectedTrainSetMappingHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-set-mapping/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    saveTrainSetMapping: (context, trainSetMapping) => {
      return (
        axios
          //TODO
          .post(context.getters.getMcServiceUrl + "/train-set-mapping/entity", trainSetMapping)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadTrainSetMapping: (context, trainSetMapping) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/train-set-mapping/entity/" + trainSetMapping.id)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadDraftTrainSetMapping: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-set-mapping/entity/draft/" + intentId).then((response) => {
        context.commit("setSelectedTrainSetMapping", response.data);
        return response.data;
      });
    },
    publishTrainSetMapping: (context, trainSetMapping) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/train-set-mapping/publish/" + trainSetMapping.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    recallTrainSetMapping: (context, trainSetMapping) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-set-mapping/recall/" + trainSetMapping.intentId).then((response) => {
        return response.data;
      });
    },
    rejectTrainSetMapping: (context, trainSetMapping) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-set-mapping/reject/" + trainSetMapping.intentId).then((response) => {
        return response.data;
      });
    },
    cancelTrainSetMapping: (context, trainSetMapping) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-set-mapping/cancel/" + trainSetMapping.intentId).then((response) => {
        return response.data;
      });
    },
    deleteTrainSetMapping: (context, trainSetMapping) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-set-mapping/entity/" + trainSetMapping.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          trainSetMapping.intents = intents;
          trainSetMapping.intentId = response.data.id;
          return trainSetMapping;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTrainSetMapping: (context, trainSetMapping) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-set-mapping/draft/" + trainSetMapping.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
  },

  getters: {
    getTrainSetMappings: (state) => {
      return state.trainSetMapping;
    },
    getSelectedTrainSetMapping: (state) => {
      return state.selectedTrainSetMapping;
    },
  },
};
